import styled from 'styled-components';

export const ButtonGroupContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 18px 20px;
`;

export const ButtonGroupLabel = styled.p`
    align-self: center;
    font-size: 18px;
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: 400;
    color: #0d0d0d;
    margin: 0;
`;

export const ButtonGroupButtonsRow = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

export const ButtonGroupButton = styled.button<{ disabled?: boolean; isSelected?: boolean }>`
    padding: 9px 16px;
    border-radius: 6px;
    border: ${({ isSelected }) => (isSelected ? '2px solid #00697C' : '1px solid #7E7E7E')};
    font-size: 16px;
    line-height: 20px;
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'normal')};
    cursor: pointer;
`;
